import Layout from "src/components/layout";
import { Button } from "src/components/ui/button";
import { ComboboxForm } from "src/components/ui/combobox";
import { Input } from "src/components/ui/input";
import { Textarea } from "src/components/ui/textarea";

export default function ContactUs() {
  return (
    <Layout>
      <div className="bgHeroBanner">
        <div className="grid grid-cols-[2fr_5fr] md:grid-cols-[2fr_4fr] gap-4 px-3 max-w-[1400px] mx-auto py-[5%] items-center">
          <div className="mt-14 mx-auto max-w-[1400px] lg:flex lg:gap-9">
            <div className="[&>img]:mb-5 md:[&>img]:w-[150px]">
              <img
                className="h-auto w-[110px] lg:group-hover:w-[150px] lg:duration-1000"
                src={require("../../assets/countryFlags/ElSalvador.png")}
                alt="El Salvador"
              />
              <img
                className="h-auto w-[110px] lg:group-hover:w-[150px] lg:duration-1000"
                src={require("../../assets/countryFlags/Panama.png")}
                alt="Panama"
              />
              <img
                className="h-auto w-[110px] lg:group-hover:w-[150px] lg:duration-1000"
                src={require("../../assets/countryFlags/Honduras.png")}
                alt="Honduras"
              />
              <img
                className="h-auto w-[110px] lg:group-hover:w-[150px] lg:duration-1000"
                src={require("../../assets/countryFlags/Nicaragua.png")}
                alt="Nicaragua"
              />
            </div>
            <div className="[&>img]:mb-5 lg:mt-9 md:[&>img]:w-[150px]">
              <img
                className="h-auto w-[110px] lg:group-hover:w-[150px] lg:duration-1000"
                src={require("../../assets/countryFlags/Belize.png")}
                alt="Belize"
              />
              <img
                className="h-auto w-[110px] lg:group-hover:w-[150px] lg:duration-1000"
                src={require("../../assets/countryFlags/Guatemala.png")}
                alt="Guatemala"
              />
              <img
                className="h-auto w-[110px] lg:group-hover:w-[150px] lg:duration-1000"
                src={require("../../assets/countryFlags/CostaRica.png")}
                alt="Costa Rica"
              />
            </div>
          </div>
          <div className="text-white mt-14 lg:flex lg:gap-6">
            <h1 className="text-4xl font-bold max-w-min">Contact Us</h1>
            <div>
              <p className="mt-8 lg:mt-20 w-[80%]">
                Do you have a question? We're here to help. Send us a message
                and we'll be in contact
              </p>

              <div className="flex flex-col gap-6 justify-center mt-4 max-w-[800px]">
                <Input
                  type="text"
                  className="bg-[#515151] bg-opacity-80 border-none h-16 sm:w-[90%] min-w-[200px] placeholder:text-left placeholder:text-white"
                  placeholder="YOUR NAME"></Input>
                <ComboboxForm></ComboboxForm>
                <Input
                  type="email"
                  className="bg-[#515151] bg-opacity-80 border-none h-16 sm:w-[90%] min-w-[200px] placeholder:text-left placeholder:text-white"
                  placeholder="EMAIL"></Input>
                <Textarea
                  className="bg-[#515151] bg-opacity-80 h-[120px] sm:h-[300px] border-none sm:w-[90%] min-w-[200px] placeholder:text-left placeholder:text-white"
                  placeholder="YOUR MESSAGE HERE"></Textarea>
                <Button className="h-16 sm:w-[90%] font-extrabold">SEND</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
